import { IconChevronLeft16 } from '@warp-ds/icons/react/chevron-left-16';
import { Button } from '@warp-ds/react';
import React from 'react';

type ParentCategoryButtonProps = {
    className?: string;
    label: string;
    onClick?: () => void;
};

export function ParentCategoryButton(props: ParentCategoryButtonProps) {
    const { className = '', label, onClick } = props;

    return (
        <Button
            className={`${className} flex items-center space-x-4 text-left`}
            link
            onClick={onClick}
        >
            <IconChevronLeft16 />
            <span>{label}</span>
        </Button>
    );
}
